<script>
import baseEdit from "@/views/components/base/baseEdit.vue";
export default {
  extends: baseEdit,
  components: {},
  data() {
    return {
      mname: "patrol",
      key: "id",
      url: {
        get: "/admin/system/patrol",
        add: "/admin/system/patrol",
        edit: "/admin/system/patrol",
      },
      items: [
        { label: "新增定时巡检",  type: "header" },
        // {
        //   label: "巡检名称",
        //   name: "patrolName",
        //   value: "",
        //   type: "input",
        //   width: "200px",
        //   rules: [{ required: true, trigger: "blur" }],
        // },
        {
          label: "巡检维度类别",
          name: "patrolDimension",
          value: 1,
          type: "select",
          width: "240px",
          dropList: [
            { value: 1, name: "设备" },
            { value: 2, name: "巡检类别" },
          ],
          rules: [{ required: true, trigger: "blur", type: "number" }],
          onChange: this.onChangeType,
        },
        {
          label: "",
          name: "facilityList",
          value: "",
          type: "multiple",
          filterable: true,
          dropList: [],
          onChange: this.onCouponAlis,
        },
        {
          label: "",
          name: "patrolTypeId",
          value: "",
          type: "select",
          dropList: [],
          // onChange: this.onCouponAlis,
        },


        {
          label: "巡检周期",
          name: "patrolInterval",
          value: "",
          type: "number",
          min: 0,
          precision: 0,
          width: "200px",
          rules: [{ required: true, trigger: "blur", type: "number" }],
        },
        {
          label: "周期单位",
          name: "timeUnit",
          value: "",
          type: "select",
          width: "240px",
          dropList: [
            // {
            //   value: 1,
            //   name: "分钟",
            // },
            // {
            //   value: 2,
            //   name: "小时",
            // },
            {
              value: 3,
              name: "天",
            },
            // {
            //   value: 4,
            //   name: "周",
            // },
            {
              value: 5,
              name: "月",
            },
            // {
            //   value: 6,
            //   name: "季度",
            // },
            // {
            //   value: 7,
            //   name: "年",
            // },
          ],
          rules: [{ required: true, trigger: "blur", type: "number" }],
        },
        {
          label: "巡检开始时间",
          name: "patrolBeginTime",
          value: "",
          type: "datetoday",
        },
        // {
        //   label: "巡检内容",
        //   name: "patrolContent",
        //   value: "",
        //   type: "textarea",
        //   width: "400px",
        // },
        // { label: "备注", name: "remark", value: "", type: "textarea",width:"400px" },
        {
          label: "负责人",
          name: "maintainerId",
          value: "",
          type: "select",
          width: "240px",
          dropList: [],
          rules: [{ required: true, trigger: "blur", type: "number" }],
        },
        {
          label: "楼宇",
          name: "buildingId",
          value: "",
          type: "select",
          width: "200px",
          dropList: [],
          onChange: this.getFloor
          // rules: [{ required: true, trigger: "blur", type: "number" }],
        },
        {
          label: "楼层",
          name: "floorId",
          value: "",
          type: "select",
          width: "200px",
          dropList: [],
          // rules: [{ required: true, trigger: "blur", type: "number" }],
        },

        {
          label: "房间号",
          name: "room",
          value: "",
          type: "input",
          width: "200px",
          // rules: [{ required: true, trigger: "blur", type: "number" }],
        },
        // { label: '知识库标签', name: 'category_id', value: '', type: 'tree', dropList: [], rules: [{ required: true, trigger: 'blur', type: 'number' }] },
        // { label: '详情', name: 'detail', value: '', type: 'editor' },
      ],
      forms: {},
    };
  },
  created() {
    this.loaduserData();
    this.loadfacilityNoData();
    this.loadfacilityNoData1();
    this.getBuilding()
  },
  mounted() {
    this.onChangeType(1);
    this.forms.patrolDimension = 1;
    this.items[this.getItemIndex("patrolDimension")].value = 1;
  },
  methods: {
    handleSubmit() {
      if (!this.action) {
        return true;
      }
      let q = this.forms;
      this.forms.facilityList = this.Listid;
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.sloading = true;
          $utils.api
            .load(
              `/admin/system/patrol`,
              q,
              this.action == "edit" ? "PUT" : "POST"
            )
            .then((res) => {
              this.sloading = false;
              if (res.status) {
                $utils.toast.success("保存成功");
                $utils.url.go(-1);
              }
            })
            .catch((e) => {
              this.sloading = false;
              $utils.toast.error("保存异常" + e.message);
            });
        }
      });
    },
    onCouponAlis(val) {
      let ass = val.join(",");
      this.Listid = ass
    },
    loadfacilityNoData() {
      // 通过pk查询字典数据
      let q = {state:2};
      $utils.api.load("/admin/system/facility/selectList", q).then((res) => {
        if (res && res.rows) {
          let ll = res.rows;
          let dropList = [];
          for (let index = 0; index < ll.length; index++) {
            const element = ll[index];
            let xx = {};
            xx.value = element.id;
            xx.name = element.facilityName + "/" + element.facilityType + "/" + element.installationSite;
            xx.children = element.children || [];
            dropList.push(xx);
          }
          for (let index = 0; index < this.items.length; index++) {
            const element = this.items[index];
            if (element && element.name == "facilityList") {
              // this.items[index]['dropList'] = dropList
              this.items[index]["dropList"] = (
                this.items[index]["dropList"] || []
              ).concat(dropList);
            }
          }
          console.log(444, dropList)
        }
      });
    },
    loadfacilityNoData1() {
      // 通过pk查询字典数据
      let q = {};
      $utils.api.load("/admin/system/patrolType/selectList", q).then((res) => {
        if (res && res.rows) {
          let ll = res.rows;
          let dropList = [];
          for (let index = 0; index < ll.length; index++) {
            const element = ll[index];
            let xx = {};
            xx.value = element.id;
            xx.name = element.typeName;
            xx.children = element.children || [];
            dropList.push(xx);
          }
          for (let index = 0; index < this.items.length; index++) {
            const element = this.items[index];
            if (element && element.name == "patrolTypeId") {
              // this.items[index]['dropList'] = dropList
              this.items[index]["dropList"] = (
                this.items[index]["dropList"] || []
              ).concat(dropList);
            }
          }
        }
      });
    },
    onChangeType(val) {
      if (val == 1) {
        this.items[this.getItemIndex("patrolTypeId")].type = "kong";
        this.items[this.getItemIndex("facilityList")].type = "multiple";
      }
      if (val == 2) {
        this.items[this.getItemIndex("patrolTypeId")].type = "select";
        this.items[this.getItemIndex("facilityList")].type = "kong";
      }
    },
    loaduserData() {
      // 通过pk查询字典数据
      $utils.api.load(`/admin/system/maiUser/insList`, {}, "get").then((res) => {
        if (res && res.data) {
          let ll = res.data;
          let dropList = [];
          for (let index = 0; index < ll.length; index++) {
            const element = ll[index];
            let xx = {};
            xx.value = element.userId;
            xx.name = element.nickName;
            xx.children = element.children || [];
            dropList.push(xx);
          }
          for (let index = 0; index < this.items.length; index++) {
            const element = this.items[index];
            if (element && element.name == "maintainerId") {
              // this.items[index]['dropList'] = dropList
              this.items[index]["dropList"] = (
                this.items[index]["dropList"] || []
              ).concat(dropList);
            }
          }
        }
      });
    },
    async getBuilding() {
      let d = {}
      let res = await $utils.api.load('admin/system/building/list', d, "get")
      // console.log(res);
      if (res.code == 200) {
        // this.buildingList = res.rows
        let ll = res.rows;
        let dropList = [];
        for (let index = 0; index < ll.length; index++) {
          const element = ll[index];
          let xx = {};
          xx.value = element.id;
          xx.name = element.buildingName;
          // xx.children = element.children || [];
          dropList.push(xx);
        }
        for (let index = 0; index < this.items.length; index++) {
          const element = this.items[index];
          if (element && element.name == "buildingId") {
            // this.items[index]['dropList'] = dropList
            this.items[index]["dropList"] = (
              this.items[index]["dropList"] || []
            ).concat(dropList);
          }
        }
      }
    },
    async getFloor(e) {
      let d = {
        buildingId: e
      }
      let res = await $utils.api.load("admin/system/floor/list", d, "get")
      // console.log(res);
      if (res.code == 200) {
        // this.floorList = res.rows
        let ll = res.rows;
        let dropList = [];
        for (let index = 0; index < ll.length; index++) {
          const element = ll[index];
          let xx = {};
          xx.value = element.id;
          xx.name = element.floorName;
          // xx.children = element.children || [];
          dropList.push(xx);
        }
        for (let index = 0; index < this.items.length; index++) {
          const element = this.items[index];
          if (element && element.name == "floorId") {
            console.log(123456);
            // this.items[index]['dropList'] = dropList
            this.items[index]["dropList"] = (
              this.items[index]["dropList"] || []
            ).concat(dropList);
          }
        }
      }
    },
  },
};
</script>
